"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AvatarWrapper = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageWithFalback = _interopRequireDefault(require("../ImageWithFalback"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AvatarWrapper = function AvatarWrapper(_ref) {
  var children = _ref.children,
      hidden = _ref.hidden,
      src = _ref.src,
      fallback = _ref.fallback;
  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: "jsx-3944193325" + " " + 'avatar-wrapper'
  }, _react["default"].createElement("div", {
    className: "jsx-3944193325" + " " + 'avatar-wrapper-icon'
  }, !hidden && _react["default"].createElement(_ImageWithFalback["default"], {
    src: src,
    fallback: fallback,
    alt: "",
    style: {
      border: '1px solid #A8A8A8',
      borderRadius: '50%',
      borderBottomRightRadius: '0'
    }
  })), _react["default"].createElement("div", {
    className: "jsx-3944193325" + " " + 'avatar-wrapper-children'
  }, children)), _react["default"].createElement(_style["default"], {
    id: "3944193325"
  }, ".avatar-wrapper.jsx-3944193325{position:relative;padding-left:25px;}.avatar-wrapper-icon.jsx-3944193325{position:absolute;top:-34px;left:-7px;height:46px;width:46px;}"));
};

exports.AvatarWrapper = AvatarWrapper;
AvatarWrapper.propTypes = {
  children: _propTypes["default"].node.isRequired,
  src: _propTypes["default"].string.isRequired,
  fallback: _propTypes["default"].string.isRequired,
  hidden: _propTypes["default"].bool
};
var _default = AvatarWrapper;
exports["default"] = _default;